function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  border-radius: 16px;\n  background: var(--media-processing-surface, #f8fafc);\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.08);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--media-processing-title, #1f2937);\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 14px;\n  background: var(--media-processing-item-bg, #ffffff);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);\n\n  &:not(:last-of-type) {\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  flex-shrink: 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.75rem;\n  background: rgba(148, 163, 184, 0.18);\n  color: var(--media-processing-icon, #475569);\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-width: 0;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--media-processing-name, #111827);\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.5rem;\n  padding: 0.125rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: rgba(239, 68, 68, 0.14);\n  color: rgb(220, 38, 38);\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  height: 6px;\n  border-radius: 9999px;\n  background: rgba(148, 163, 184, 0.32);\n  overflow: hidden;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  width: ",
        "%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #38bdf8 0%, #6366f1 100%);\n  transition: width 0.3s ease;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  margin: 0.35rem 0 0;\n  font-size: 0.75rem;\n  color: rgba(71, 85, 105, 0.9);\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 9999px;\n  border: 2px solid rgba(148, 163, 184, 0.4);\n  border-top-color: rgba(59, 130, 246, 0.9);\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 9999px;\n  background: rgba(239, 68, 68, 0.16);\n  color: rgb(220, 38, 38);\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.75rem;\n  color: rgb(220, 38, 38);\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.75rem;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 9999px;\n  background: rgba(148, 163, 184, 0.16);\n  color: rgba(71, 85, 105, 0.9);\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n\n  &:hover {\n    background: rgba(71, 85, 105, 0.18);\n    color: rgba(15, 23, 42, 0.85);\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
export var ProcessingContainer = styled.div(_templateObject());
export var ProcessingHeader = styled.h4(_templateObject1());
export var ProcessingItem = styled.div(_templateObject2());
export var MediaIcon = styled.div(_templateObject3());
export var ProcessingBody = styled.div(_templateObject4());
export var ProcessingName = styled.span(_templateObject5());
export var StatusBadge = styled.span(_templateObject6());
export var ProgressBarContainer = styled.div(_templateObject7());
export var ProgressBar = styled.div(_templateObject8());
export var ProgressBarFill = styled.div(_templateObject9(), function(param) {
    var progress = param.progress;
    return Math.min(100, Math.max(0, progress));
});
export var ProgressDescription = styled.p(_templateObject10());
export var ProcessingSpinner = styled.div(_templateObject11());
export var ErrorIcon = styled.div(_templateObject12());
export var ErrorText = styled.span(_templateObject13());
export var RemoveProcessingButton = styled.button(_templateObject14());
